module.exports = __webpack_public_path__ + "kichler.svg?7b05f99701e4f3acfae4743b210276ac";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/kichler.svg
// module id = 624
// module chunks = 0